<template>
  <div class="page-content row" id="UserInvite">
    <div class="col s12 m11 main-page-content">

      <div class="col l3 sidebar hide-on-med-and-down">
        <div class="card">
          <user-info />
        </div>

        <div class="card">
          <contact/>
        </div>

        <div class="card">
          <find-us/>
        </div>
      </div>

      <div class="col s12 l9">
        <div class="card standard-card">
          <h4>Wypełnij brakujące informacje</h4>
          <AccountDetailsForm @sendSuccess="showSuccessModal"/>
        </div>
      </div>
    </div>

    <modal-success-account-details v-if="showModal" :showModal="showModal" @close="closeSuccessModal" />
  </div>
</template>

<script>
import FindUs from '@/components/findUs'
import Contact from '@/components/contact'
import UserInfo from '@/components/userInfo'
import AccountDetailsForm from '@/components/accountDetailsForm/index'
import ModalSuccessAccountDetails from '@/components/modalSuccessAccountDetails'

export default {
  components: { UserInfo, FindUs, Contact, AccountDetailsForm, ModalSuccessAccountDetails },
  name: 'AccountDetails',
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    showSuccessModal () {
      this.showModal = !this.showModal
    },
    closeSuccessModal () {
      this.$router.push({name: 'dashboard'})
    }
  }
}
</script>
<style lang="scss">
@import './base';

.standard-card {
  h4 {
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// accountDetails.vue?d1259b9e